export default "__VITE_ASSET__BBMIR0DL__"